module.exports = __webpack_public_path__ + "img/39-CAMICIA-SUSHI-SMLXL-COLORI-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO1.7aac9e93.jpg";